import apiCall from 'apps/wealth/apiCalls/user-assignments';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './form';

const listUrl = '/wealth/user-assignments';

export const UserAssignmentsListPage = () => (
  <ListPage
    title="Wealth Assignments"
    description="Assign users to staff accounts for Private Wealth access."
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    createUrl={`${listUrl}/create`}
  />
);

export const UserAssignmentsCreatePage = () => (
  <CreatePage
    title="Wealth Assignment"
    apiCall={apiCall}
    listUrl={listUrl}
    ItemForm={ItemForm}
    resourceName="data"
  />
);

export const UserAssignmentsDetailPage = () => (
  <DetailPage
    title="Wealth Assignment"
    apiCall={apiCall}
    listUrl={listUrl}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: true }}
  />
);

export const UserAssignmentsEditPage = () => (
  <EditPage
    title="Wealth Assignment"
    apiCall={apiCall}
    listUrl={listUrl}
    ItemForm={ItemForm}
    resourceName="data"
  />
);
